import React from "react";
import Kurs from "../../components/AdminPanel/DarsJadval/Kurs";

const AdminKurs = () => {
    return (
            <div>
                <Kurs />
            </div>
        );
};

export default AdminKurs;
